import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const notificationApi = createAsyncThunk(
  "notification",
  async ({ startDate = null, endDate = null }) => {
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    const response = await axiosInstance.get("/send", { params });
    return response.data;
  }
);

const sipSlice = createSlice({
  name: "notification",
  initialState: {
    notification: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(notificationApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(notificationApi.fulfilled, (state, action) => {
        state.notification = action.payload;
        state.loading = false;
      })
      .addCase(notificationApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default sipSlice.reducer;
